import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import dayjs from 'dayjs';

import TotalMembersPageHeader from './components/TotalMembersPageHeader';
import TotalMembersTable from './components/TotalMembersTable';
import { SearchFilters } from './types';

const TotalMembers = (): JSX.Element => {
  const initialSearchFiltersValue: SearchFilters = {
    date: dayjs().endOf('day').toDate(),
  };

  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<SearchFilters>(searchFilters, 250);
  const [orderingValue, setOrderingValue] = useState<string>('firstName');

  return (
    <>
      <TotalMembersPageHeader
        initialSearchFiltersValue={initialSearchFiltersValue}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        orderingValue={orderingValue}
      />

      <TotalMembersTable searchFilters={debouncedSearchFilters} setOrderingValue={setOrderingValue} />
    </>
  );
};

export default TotalMembers;
